export default "__VITE_ASSET__4a049785__"